import { defineMessages } from 'react-intl';

export const messages: {
	noPaymentDetailsLegalTextFree: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noPaymentDetailsLegalTextPremium: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noPaymentDetailsLegalTextStandard: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	paymentDetailsLegalTextFree: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	paymentDetailsLegalTextPremium: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	paymentDetailsLegalTextStandard: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	noPaymentDetailsLegalTextPremium: {
		id: 'twc.xflow.modal.legal.noPaymentDetailsLegalText.loom.premium',
		defaultMessage:
			'30-day free trial of Premium plan. By selecting "{cta}" you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy.</pp>. Cancel anytime',
		description:
			'Legal notice for tenants on the Premium edition that do not have payment details on file',
	},
	noPaymentDetailsLegalTextStandard: {
		id: 'twc.xflow.modal.legal.noPaymentDetailsLegalText.loom.standard',
		defaultMessage:
			'14-day free trial of Standard plan. By selecting "{cta}" you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy.</pp>. Cancel anytime',
		description:
			'Legal notice for tenants on the Standard edition that do not have payment details on file',
	},
	paymentDetailsLegalTextPremium: {
		id: 'twc.xflow.modal.legal.paymentDetailsLegalText.loom.premium.ubp',
		defaultMessage:
			'30-day free trial of Premium plan. By selecting "{cta}" you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy.</pp> If you don\'t cancel during the trial, subscription billing will begin and renew monthly based on pricing of Teamwork Collection. For meters, extra usage is enabled. Cancel anytime.{br}',
		description:
			'Legal notice for tenants on the Premium edition that have payment details on file. Includes the usage-based pricing (UBP) extra usage disclosure required by Legal.',
	},
	paymentDetailsLegalTextStandard: {
		id: 'twc.xflow.modal.legal.paymentDetailsLegalText.loom.standard.ubp',
		defaultMessage:
			'14-day free trial of Standard plan. By selecting "{cta}" you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy.</pp> If you don\'t cancel during the trial, subscription billing will begin and renew monthly based on pricing of Teamwork Collection. For meters, extra usage is enabled. Cancel anytime.{br}',
		description:
			'Legal notice for tenants on the Standard edition that have payment details on file. Includes the usage-based pricing (UBP) extra usage disclosure required by Legal.',
	},
	noPaymentDetailsLegalTextFree: {
		id: 'twc.xflow.modal.legal.noPaymentDetailsLegalText.loom.free',
		defaultMessage:
			'Cancel anytime. By selecting "{cta}" you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy.</pp>',
		description:
			'Plan-agnostic legal notice for Free-edition tenants that do not have payment details on file (no trial duration mentioned).',
	},
	paymentDetailsLegalTextFree: {
		id: 'twc.xflow.modal.legal.paymentDetailsLegalText.loom.free.ubp',
		defaultMessage:
			'By selecting "{cta}" you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy.</pp> If you don\'t cancel during the trial, subscription billing will begin and renew monthly based on pricing of Teamwork Collection. For meters, extra usage is enabled. Cancel anytime.{br}',
		description:
			'Plan-agnostic legal notice for Free-edition tenants that have payment details on file (no trial duration mentioned). Includes the usage-based pricing (UBP) extra usage disclosure required by Legal.',
	},
});
